import { Button } from 'antd';
import { ArrowRightOutlined } from '@ant-design/icons';

const nodes = [
    { x: 35, y: 112, r: 8, tone: 'variant' },
    { x: 108, y: 83, r: 9, tone: 'neutral' },
    { x: 80, y: 156, r: 7, tone: 'control' },
    { x: 166, y: 130, r: 15, tone: 'variant' },
    { x: 190, y: 48, r: 10, tone: 'neutral' },
    { x: 229, y: 107, r: 13, tone: 'variant' },
    { x: 263, y: 40, r: 7, tone: 'neutral' },
    { x: 294, y: 74, r: 7, tone: 'neutral' },
    { x: 276, y: 153, r: 11, tone: 'variant' },
    { x: 223, y: 210, r: 10, tone: 'variant' },
    { x: 145, y: 204, r: 8, tone: 'neutral' },
    { x: 329, y: 172, r: 6, tone: 'control' },
];

const edges = [
    [0, 1], [0, 2], [1, 3], [3, 4], [4, 6], [3, 5],
    [5, 6], [5, 9], [3, 8], [7, 8], [8, 9], [8, 11], [9, 10],
];

export default function RgnetIntro({ onOpen }) {
    return (
        <section className="display-rgnet-section" aria-labelledby="rgnet-intro-title">
            <div className="display-section-shell">
                <div className="display-rgnet-panel">
                    <div className="display-rgnet-content">
                        <span className="display-rgnet-label">RGNET</span>
                        <h2 id="rgnet-intro-title">Explore Recessive Genotype Networks</h2>
                        <p>
                            Explore how variants combine into recessive genotypes within a cohort,
                            and use network evidence to support variant interpretation.
                        </p>
                        <Button className="display-rgnet-link" onClick={onOpen}>
                            Open RGNET Explorer <ArrowRightOutlined />
                        </Button>
                    </div>
                    <svg className="display-rgnet-network" viewBox="0 0 360 245" aria-hidden="true" focusable="false">
                        <g className="display-rgnet-edges">
                            {edges.map(([from, to]) => (
                                <line key={`${from}-${to}`} x1={nodes[from].x} y1={nodes[from].y} x2={nodes[to].x} y2={nodes[to].y} />
                            ))}
                        </g>
                        {nodes.map((node, index) => (
                            <circle key={index} className={`display-rgnet-node is-${node.tone}`} cx={node.x} cy={node.y} r={node.r} />
                        ))}
                    </svg>
                </div>
            </div>
        </section>
    );
}
